module.exports = __webpack_public_path__ + "media/images/pages/fcr/about-fb1287b62303fcbae5631168fe165d79.png";